import axios from 'axios';

export const api = axios.create({
	baseURL: process.env.VUE_APP_API_URL || 'https://1api.goleko.com/api',
})

api.online = true
export const tab_uuid = uuidv4()

api.interceptors.request.use(
	config => {
		const token = localStorage.getItem('token');
		if (token) config.headers['Authorization'] = `Bearer ${token}`
		config.headers['Tab_ID'] = tab_uuid

		return config;
	},
	error => Promise.reject(error),
);

window.addEventListener('online', () => {
	console.log('online')
	api.online = true;
});

window.addEventListener('offline', () => {
	console.log('offline')
	api.online = false;
});

function uuidv4() {
	return "10000000-1000-4000-8000-100000000000".replace(/[018]/g, c =>
		(c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
	);
}
